<template lang="pug">
  .wrapper-company-list
    h2 {{ $wp('company') }}
    .filters
      .total
        span total de {{ $wp('company') }}: {{ totalCompanies }}
      .buttons
        .report
          PButton(
            color="primary"
            size="md"
            @click="genReport"
            title = "Gerar excel com todos os locais de trabalho"
            block
          )
            | gerar relatório
        .new
          PButton(
            color="warning"
            size="md"
            @click="createNew"
            block
          )
            | criar novo {{ $ws('company') }}

    .table
      SmartTable(name="company-list" v-bind="table" v-model="tableData" @rowClick="onSelectedCompany" ref="table")
        template(v-slot:default="slotProps")
          TableRow(v-bind="slotProps")
            template(v-slot:active="{ columnValue, rowItem, index }")
              .active
                .icon.fs-19.icon-ptt-icons-predio-ativo.color-success(v-if="columnValue === true")
                .icon.fs-19.icon-ptt-icons-predio-inativo(v-else)

            template(v-slot:name="{ columnValue }")
              span.no-wrap(:title="columnValue") {{ columnValue }}

            template(v-slot:region="{ columnValue, rowItem, index }")
              span.no-wrap(
                v-if="!reloadingCompanyInfo"
                :title="columnValue ? formatedRegion(columnValue) : ''"
              )
                | {{ columnValue ? formatedRegion(columnValue) : '' }}
              .loading-field(v-else key="loading-region")

            template(v-slot:code="{ columnValue, rowItem, index }")
              span.no-wrap(:title="columnValue") {{ columnValue }}

            template(v-slot:ddd="{ columnValue, rowItem, index }")
              template(v-if="!reloadingCompanyInfo") {{ columnValue }}
              .loading-field(v-else key="loading-ddd")

            template(v-slot:totalOfEmployees="{ columnValue, rowItem, index }")
              template(v-if="!reloadingCompanyInfo") {{ columnValue }}
              .loading-field(v-else key="loading-totalOfEmployees")

        template(v-slot:detailsBox="{item}")
          Details(:company="companyInfoPerId[item.id]" :loading="loadingSelectedCompanyInfo" @updateTable="updateTable")
</template>

<script>
import { includesSearch, getHierarchyName } from 'src/utils'
import Details from './Details'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'CompanyList',
  async created () {
    await this.getRegions()
  },
  data () {
    return {
      selectedCompany: {
        index: null,
        item: null
      },
      reloadingCompanyInfo: false,
      companyInfoPerId: {},
      table: {
        headerItems: [
          {
            column: 'status',
            field: 'active',
            width: '0.23fr',
            options: [
              {iconClass: 'icon-ptt-icons-predio-ativo', text: 'Todos'},
              {iconClass: 'icon-ptt-icons-predio-ativo', text: 'Ativo'},
              {iconClass: 'icon-ptt-icons-predio-inativo', text: 'Inativo'}
            ],
            filterFunction: ({search, item}) => {
              if (search === 'Todos') return true

              return search === 'Ativo' ? item.active === true : item.active === false
            }
          },
          {column: 'nome', field: 'name', width: '1fr'},
          {column: 'código', field: 'code', width: '0.4fr'},
          {
            column: 'região',
            field: 'region',
            width: '.5fr',
            filterFunction: ({search, item}) => includesSearch(item.region.name, search)
          },
          {column: 'ddd', field: 'ddd', width: '.2fr'},
          {
            column: `nº de ${this.$wp('employee')}`,
            field: 'totalOfEmployees',
            width: '.40fr',
            filterFunction: ({search, item}) => parseInt(search) === item.totalOfEmployees
          }
        ],
        config: {
          perPage: 15,
          startFocusedSearch: 'name',
          defaultSortField: 'name',
          defaultColumnSearch: 'name',
          defaultFilterText: {field: 'active', text: 'Ativo'}
        }
      }
    }
  },
  mounted () {
    this.updateTable()
    setAmplitudeEvent('lista local de trabalho', {})
  },
  computed: {
    totalCompanies () {
      return this.$store.state.common.companies.items.length
    },
    tableData: {
      get () {
        return {loaded: this.$store.state.common.companies.items}
      },
      set ({selected}) {
        this.selectedCompany = selected
      }
    }
  },
  methods: {
    async getRegions () {
      this.reloadingCompanyInfo = true
      await this.$store.dispatch('common/regions/fetchItems')
      this.reloadingCompanyInfo = false
    },
    async updateTable (reloadAllCompanies = false) {
      this.reloadingCompanyInfo = true
      this.closeDetailsTable()

      await this.$store.dispatch('common/companies/fetchItems', {
        withFields: ['name', 'code', 'total_of_employees', 'ddd', 'region', 'active', 'color'],
        fullReload: reloadAllCompanies
      })

      this.reloadingCompanyInfo = false
    },
    createNew () {
      this.$router.push('/company/new')
    },
    async genReport () {
      const statusOptions = {
        'Todos': 'all',
        'Ativo': 'active',
        'Inativo': 'inactive'
      }
      const statusFilter = statusOptions[this.$refs.table.search.active]

      let result
      try {
        result = await this.$API.companiesReport.save({
          company_status: statusFilter
        })
        if (result.data.error) {
          this.$modalDeErro(result?.data?.error ? result.data.error : 'Não foi possível gerar o relatório')
        } else {
          this.$modalDeSucesso(result.data.success)
        }
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível gerar o relatório')
      }
    },
    closeDetailsTable () {
      this.$refs.table.closeDetailsBox()
    },
    async onSelectedCompany (company) {
      if (!this.companyInfoPerId[company.id]) {
        this.$set(this.companyInfoPerId, company.id, {...company})

        this.loadingSelectedCompanyInfo = true

        const completeInfo = await this.$API.company.get({
          id: company.id,
          fields: JSON.stringify([
            'id',
            'code',
            'name',
            'phone',
            'total_of_employees',
            'ddd',
            'last_synced_with_timezone',
            'last_punched_with_timezone',
            'region',
            'active',
            'color',
            'reserve',
            'supervisor',
            'location',
            'priority',
            'appear_on_realtime'
          ])
        })

        this.$set(this.companyInfoPerId, company.id, completeInfo.data.success[0])

        this.loadingSelectedCompanyInfo = false
      }
    },
    formatedRegion (region) {
      const regions = this.$store.state.common.regions.items
      return regions.length ? getHierarchyName(region, regions) : ''
    }
  },
  components: {Details}
}
</script>

<style scoped lang="scss">
.wrapper-company-list {
  display: grid;
  grid-template-rows: min-content min-content auto;
  grid-template-columns: 1fr;

  h2 {
    text-align: center;
  }

  .filters {
    margin-bottom: var(--header-margin-bottom);
    grid-row: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2px;
    align-items: center;

    .buttons {
      display: flex;
      justify-content: flex-end;

      :not(:first-child) {
        margin-left: 2px;
      }
    }
  }

  .table {
    grid-row: 3;

    .loading-field {
      width: 30%;
      height: 60%;
      background-color: lightgray;
    }

    .active {
      height: 100%;
      display: grid;
      align-items: center;
      justify-items: left;
      padding-left: 20px;
    }
  }
}
</style>

<style>
/* Just to remove default padding to smart table... */
.wrapper-company-list .table .wrapper-smart-table .grid .row .body-column:first-child {
  padding-left: 0;
}
</style>
